import React from "react";
import styles from "./stepFooter.scss";

const StepFooter = ({ rightButton, middleButton, leftButton }) => (
  <div className={styles.container}>
    <div className={`${styles.left} ${middleButton ? styles.hasMiddle : ""}`}>
      {leftButton}
    </div>
    {middleButton && <div className={styles.middle}>{middleButton}</div>}
    <div className={styles.right}>{rightButton}</div>
  </div>
);

StepFooter.defaultProps = {
  rightButton: null,
  leftButton: null,
  middleButton: null
};

export default StepFooter;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/StepFooter/index.tsx